import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'

// Import all slice reducers
import authReducer from './slices/authSlice'
import invoiceReducer from './slices/invoiceSlice'
import customerReducer from './slices/customerSlice'
import productReducer from './slices/productSlice'
import fileReducer from './slices/fileSlice'
import zatcaReducer from './slices/zatcaSlice'
import uiReducer from './slices/uiSlice'
import columnConfigReducer from './slices/columnConfigSlice'

// Configure the store
export const store = configureStore({
  reducer: {
    auth: authReducer,
    invoices: invoiceReducer,
    customers: customerReducer,
    products: productReducer,
    files: fileReducer,
    zatca: zatcaReducer,
    ui: uiReducer,
    columnConfig: columnConfigReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'files/uploadFile/pending',
          'files/uploadFile/fulfilled',
          'files/uploadFile/rejected'
        ],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.file', 'payload.files'],
        // Ignore these paths in the state
        ignoredPaths: ['files.uploadProgress'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
})

// Export types
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Export typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

// Export store
export default store 